import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installCorpEmailGuard } from "./lib/corpEmail";
import { installMessengerClickTracking } from "./lib/messengerClick";

installCorpEmailGuard();
installMessengerClickTracking();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
